import { useEffect, useState } from 'react'
import { Grid } from '@material-ui/core'
import Api from '../../../Apis/api.service'
import ProcessCard from '../../../components/common/Cards/ProcessCard'

export const ExtCoproTicketList = (props) => {
  const copro_id = props.copro_id
  const coproprietaire_id = props?.coproprietaire?.id
  const [data, setData] = useState([])

  const fetchData = async () => {
    window.context['context-extcoproticket-coproid'] = copro_id
    window.context['context-extcoproticket-coproprietaireid'] =
      coproprietaire_id
    const res = await Api.tickets.getExtCoprosTickets()
    if (res.status == 200) {
      setData(res.data)
    }
  }
  useEffect(() => {
    fetchData()
  }, [copro_id, coproprietaire_id])
  return (
    <>
      <Grid container style={{ alignItems: 'center' }}>
        {data.map((item) => {
          return (
            <>
              <ProcessCard
                coproprietaire={props.coproprietaire}
                tickets={item.tickets}
                processName={item.name}
                linkable_type={'tickets_drafts'}
              />
            </>
          )
        })}
      </Grid>
    </>
  )
}

export default ExtCoproTicketList
